import { Box, Stack, Typography } from '@cmg/design-system';
import React from 'react';

import OfferingNote from './components/offering-note/OfferingNote';
import { OfferingNotes_OfferingNotesListPartsFragment } from './graphql';

type Props = {
  notes: OfferingNotes_OfferingNotesListPartsFragment['notes'];
  handleDeleteOfferingNote: (noteId: string) => void;
  handleEditOfferingNote: (noteId: string) => void;
};

const OfferingNotesList: React.FC<Props> = ({
  notes,
  handleDeleteOfferingNote,
  handleEditOfferingNote,
}) => {
  return (
    <Stack spacing={2}>
      {notes.map(note => (
        <OfferingNote
          key={note.id}
          note={note}
          handleDeleteOfferingNote={handleDeleteOfferingNote}
          handleEditOfferingNote={handleEditOfferingNote}
        />
      ))}
      {notes.length === 0 && (
        <Box pl={1} data-testid="offering-notes-list-empty-state">
          <Typography variant="highlight1">No internal notes added.</Typography>
        </Box>
      )}
    </Stack>
  );
};

export default OfferingNotesList;
